import { FC, ReactNode, useEffect } from "react";
import { useAppSelector } from "@/store/hooks";
import { useNavigate } from "react-router";
import { ROUTES } from "@/route/routes.constants";

interface WithAuth {
    children: ReactNode;
}

export const WithAuth: FC<WithAuth> = ({ children }) => {
    const token = useAppSelector(state => state.auth.token);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate(ROUTES.ROOT);
        }
    }, [navigate, token]);
    return (
        <>
            {children}
        </>
    );
};
